import recordApi from "app/services/http-services/record/record-api";
import sessionApi from "app/services/http-services/session/session-api";
import tableApi from "app/services/http-services/table/table-api";

const useCodeScriptFunctionInput = () => {
    const api = {
        tableApi,
        sessionApi,
        recordApi
    };

    return { api };
};

export default useCodeScriptFunctionInput;